<template>
    <div class="issue-filter">
        <span class="issue-filter-label">标题</span>
        <input v-model="selectedTitle" placeholder="请输入标题关键字">

        <span class="issue-filter-label">状态</span>
        <veui-select ui="small"
            :value="process"
            :options="processOptions"
            @change="setIssueFilterProcess"
        ></veui-select>

        <veui-button ui="primary tiny" class="issue-filter-btn"
           @click="searchForIssue">
            查找
        </veui-button>
    </div>
</template>

<style lang="less">
    @import '../../../assets/less/views/issue-filter.less';
</style>

<script>
import {Select, Button} from 'veui';
import {mapState, mapMutations} from 'vuex';

import {throttle} from '@/utils/debounceThrottle';

export default {
    props: {
        processOptions: Array,
        pageSize: Number
    },
    components: {
        'veui-select': Select,
        'veui-button': Button
    },
    computed: {
        ...mapState({
            issueFilterTitle: state => state.topicContent.issueFilterTitle,
            process: state => state.topicContent.issueFilterProcess
        }),
        selectedTitle: {
            get() {
                return this.issueFilterTitle;
            },
            set(str) {
                this.setIssueFilterTitle(str);
            }
        }
    },
    methods: {
        ...mapMutations(['setIssueFilterProcess', 'setIssueFilterTitle', 'setPageNo']),
        searchForIssue: throttle(function () {
            this.setPageNo(1);
            this.$store.dispatch('getOfficialIssueList', this.pageSize);
        })
    }
};
</script>
